(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("react-bulma-components", [], factory);
	else if(typeof exports === 'object')
		exports["react-bulma-components"] = factory();
	else
		root["react-bulma-components"] = factory();
})(this, function() {
return 